import type { TTermsGateProps } from './Terms.types.ts';
import { useTerms } from './use-terms/index.ts';

export const TermsGate = ({
  loading,
  unaccepted,
  children,
}: TTermsGateProps) => {
  const { isTermsAccepted, termsError } = useTerms();

  if (isTermsAccepted === undefined && !termsError) {
    return loading;
  }

  if (!isTermsAccepted) {
    return unaccepted;
  }

  return children;
};
